import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { Alert } from '@grandvisionhq/iris-ui';
import { useDispatch, useSelector, statusSuccess, useIntl } from '@grandvisionhq/state';
import '../../state/actions.js';
import '../../state/add-to-cart/selectors.js';
import '../../state/bundles/selectors.js';
import '../../state/bundles/reducer.js';
import { getSelectedFrame, getLensTypes, getSelectedLensType } from '../../state/configurator/selectors.js';
import '../../state/configurator/reducer.js';
import '../../state/products/selectors.js';
import '../../state/products/reducer.js';
import { VariantSelectionStep } from '../components/VariantSelectionStep/VariantSelectionStep.js';
import { selectLensType } from '../../state/configurations/actions.js';

const LensTypeVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React.createElement(LoaderScreen, null);
    }
    const variantsList = selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.variants;
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React.createElement(Failed, null);
    }
    return /*#__PURE__*/ React.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "alert-m-default variant-selection-step__alert"
    });
}

export { LensTypeVariantStepContainer };
//# sourceMappingURL=LensTypeVariantStepContainer.js.map
